import commonUrlConfig from "@adapters/infrastructures/urlConfig/Reports/commonApiUrl";
class JwtTokenNestRepository {
    constructor(http) {
        this.http = http;
    }
    async getJwtToken(requestData) {
        const url = new URL(commonUrlConfig.jwttokenfornesttraderUrl);
        const payload = {
            userID: requestData.userId,
            extoken: requestData.extoken,
        };
        const jwtTokenData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: payload,
        });
        return jwtTokenData;
    }
}
export default JwtTokenNestRepository;
